<template>
  <div class="">
    <div class="content">
      <div v-if="section" class="single">
        <Section></Section>
      </div>
      <div v-else>
        <div class="meta">
          <div class="filter">
            <v-text-field
              v-model.lazy="search"
              append-icon="search"
              :label="$t('admin.views.sections.filter')"
              single-line
              hide-details
            ></v-text-field>
          </div>
          <div class="buttons">
            <v-btn
              v-if="!section"
              outline
              @click="swapFilter('1')"
              :class="{ selected: this.filter == '1' }"
              >{{ $t('general.section_types.national') }}</v-btn
            >
            <v-btn
              v-if="!section"
              outline
              @click="swapFilter('2')"
              :class="{ selected: this.filter == '2' }"
              >{{ $t('general.section_types.local') }}</v-btn
            >
            <v-btn
              v-if="!section"
              outline
              @click="swapFilter('3')"
              :class="{ selected: this.filter == '3' }"
              >{{ $t('general.section_types.communication') }}</v-btn
            >
            <v-btn
              v-if="!section"
              outline
              @click="swapFilter('5')"
              :class="{ selected: this.filter == '5' }"
              >{{ $t('general.section_types.best_practice') }}</v-btn
            >
            <v-btn v-if="!section" outline @click="add" color="success"
              >{{ $t('admin.views.sections.create') }}</v-btn
            >
          </div>
        </div>
        <v-data-table
          :custom-filter="filterTable"
          :headers="headers"
          :items="sections"
          :no-results-text="message_not_found"
          :rows-per-page-items="rows_per_page"
          :pagination.sync="pagination"
          :search="search"
          hide-actions
          :rows-per-page-text="message_rows_per_page"
        >
          <template v-slot:items="props">
            <tr
              v-if="props.item.visible && filter == props.item.type"
              :class="{
                child: props.item.level == 0,
                child2: props.item.level == 1
              }"
            >
              <td style="margin-left: 20px;">
                <span v-for="n in props.item.level" class="separator">a</span
                ><v-icon
                  v-if="props.item.childs.length > 0 && props.item.selected"
                  @click="less(props.item.id)"
                  >expand_less</v-icon
                ><v-icon
                  v-if="!props.item.selected && props.item.childs.length > 0"
                  @click="expand(props.item.id)"
                  >expand_more</v-icon
                >
              </td>
              <td style="text-align:left">
                {{ props.item.level == 0 ? props.item.name : "" }}
              </td>
              <td style="text-align:left">
                {{ props.item.level == 1 ? props.item.name : "" }}
              </td>
              <td style="text-align:left">
                {{ props.item.level == 2 ? props.item.name : "" }}
              </td>
              <td>
                <v-icon @click="edit(props.item)">edit</v-icon
                ><v-icon @click="remove(props.item)">delete</v-icon
                ><v-icon class="up" @click="up(props.item)">arrow_upward</v-icon
                ><v-icon class="down" @click="down(props.item)"
                  >arrow_downward</v-icon
                >
              </td>
            </tr>
          </template>
        </v-data-table>
      </div>
    </div>
  </div>
</template>

<script>
import i18n from "@/i18n";
import Section from "@/components/domain/admin/Section";

export default {
  name: "Sections",
  props: { page: String },
  components: { Section },
  data() {
    return {
      headers: [
        {
          text: "",
          value: "child",
          align: "left",
          width: "150px",
          sortable: false
        },
        { text: i18n.t('admin.views.sections.header.1'), value: "name", align: "left", sortable: false },
        { text: i18n.t('admin.views.sections.header.2'), value: "name", align: "left", sortable: false },
        { text: i18n.t('admin.views.sections.header.3'), value: "name", align: "left", sortable: false },
        { text: "", value: "actions", width: "200px", sortable: false }
      ],
      search: "",
      id: -1,
      message_not_found: i18n.t('general.message_not_found'),
      message_rows_per_page: i18n.t('general.message_rows_per_page'),
      rows_per_page: [20, 50, { text: i18n.t('general.all'), value: -1 }],
      pagination: {
        rowsPerPage: -1
      },
      empty_section: { id: -1, name: "", type: -1, parent_id: -1, status: 1 },
      filter: "1",

      nivel: 0
    };
  },
  computed: {
    sections() {
      //console.log(this.$store.getters["files/getCategories"]());
      var sections = ObjectToArray(
        JSON.parse(JSON.stringify(this.$store.getters["files/getCategories"]()))
      );

      var localMinPos = -1;
      var localMaxPos = -1;

      var aSections = [];
      sections.forEach(section => {
        var childs = ObjectToArray(section.childs);
        section.visible = true;
        section.level = parseInt(section.level);
        section.path = section.name;

        if (localMinPos == -1 || section.pos < localMinPos)
          localMinPos = section.pos;
        if (localMaxPos == -1 || section.pos > localMaxPos)
          localMaxPos = section.pos;

        var aChilds = [];
        childs.forEach(child => {
          child.visible = child.visible || false;
          var childs2 = ObjectToArray(child.childs);

          child.level = parseInt(child.level);
          child.path = section.name + " > " + child.name;

          if (localMinPos == -1 || child.pos < localMinPos)
            localMinPos = child.pos;
          if (localMaxPos == -1 || child.pos > localMaxPos)
            localMaxPos = child.pos;
          var aChilds2 = [];
          childs2.forEach(child2 => {
            child2.visible = child2.visible || false;
            child2.level = parseInt(child2.level);
            child2.path =
              section.name + " > " + child.name + " > " + child2.name;
            aChilds2.push(child2);

            if (localMinPos == -1 || child2.pos < localMinPos)
              localMinPos = child2.pos;
            if (localMaxPos == -1 || child2.pos > localMaxPos)
              localMaxPos = child2.pos;
          });

          child.childs = aChilds2;
          aChilds.push(child);
        });

        section.childs = aChilds;
        aSections.push(section);
      });
      //console.log(aSections);

      sections = [];
      aSections.sort(function(a, b) {
        if (parseInt(a.pos) < parseInt(b.pos)) return -1;
        else return 1;
      });
      aSections.forEach(section => {
        sections.push(section);
        section.childs.sort(function(a, b) {
          if (parseInt(a.pos) < parseInt(b.pos)) return -1;
          else return 1;
        });
        section.childs.forEach(child => {
          sections.push(child);
          child.childs.sort(function(a, b) {
            if (parseInt(a.pos) < parseInt(b.pos)) return -1;
            else return 1;
          });
          child.childs.forEach(child2 => {
            sections.push(child2);
          });
        });
      });
      //console.log(sections);
      return sections;
    },
    section() {
      return this.$store.getters["files/getCurrentSection"];
    }
  },
  methods: {
    add() {
      this.$store.commit("files/selectSection", this.empty_section);
    },
    edit(section) {
      //console.log(section);
      this.$store.commit("files/selectSection", section);
    },
    remove(section) {
      var self = this;
      this.$popup.confirm(
        i18n.t('admin.views.sections.popup.delete'),
        i18n.t('admin.views.sections.popup.delete_message', { name: section.name }),
        i18n.t('general.delete'),
        i18n.t('general.cancel'),
        function() {
          self.$store.dispatch("files/removeSection", section.id);
        }
      );
    },
    expand(id) {
      this.$store.commit("files/expandSection", id);
    },
    less(id) {
      this.$store.commit("files/lessSection", id);
    },
    swapFilter(filter) {
      this.filter = filter;
    },
    up(section) {
      var position = section.pos;
      var item = undefined;

      if (section.level == 0) {
        var candidates = Object.values(this.sections).filter(obj => {
          return (
            obj.pos < parseInt(position) &&
            obj.level == 0 &&
            obj.type == section.type
          );
        });
        
        if (candidates.length > 0) {
          item = candidates.reduce((prev, current) => {
            return (parseInt(current.pos) > parseInt(prev.pos)) ? current : prev;
          });
        }
      } else if (section.level == 1 || section.level == 2) {
        var result = Object.values(this.sections).find(obj => {
          return obj.id == section.parent_id;
        });

        if (result != undefined) {
          var candidates = Object.values(result.childs).filter(obj => {
            return parseInt(obj.pos) < parseInt(position);
          });
          
          if (candidates.length > 0) {
            item = candidates.reduce((prev, current) => {
              return (parseInt(current.pos) > parseInt(prev.pos)) ? current : prev;
            });
          }
        }
      }

      if (item == undefined) return;

      var tempPos = section.pos;
      section.pos = item.pos;
      item.pos = tempPos;

      var self = this;
      this.$overlay.loading();
      this.$store.dispatch("files/uploadSection", section).then(function() {
        self.$store.dispatch("files/uploadSection", item).then(function() {
          self.$store.dispatch("files/loadCategories", {}).then(function() {
            self.$overlay.hide();
            section.selected = false;
          });
        });
      });
    },
    down(section) {
      var position = section.pos;
      var item = undefined;

      if (section.level == 0) {
        var candidates = Object.values(this.sections).filter(obj => {
          return (
            obj.pos > parseInt(position) &&
            obj.level == 0 &&
            obj.type == section.type
          );
        });
        
        if (candidates.length > 0) {
          item = candidates.reduce((prev, current) => {
            return (parseInt(current.pos) < parseInt(prev.pos)) ? current : prev;
          });
        }
      } else if (section.level == 1 || section.level == 2) {
        var result = Object.values(this.sections).find(obj => {
          return obj.id == section.parent_id;
        });

        if (result != undefined) {
          var candidates = Object.values(result.childs).filter(obj => {
            return parseInt(obj.pos) > parseInt(position);
          });
          
          if (candidates.length > 0) {
            item = candidates.reduce((prev, current) => {
              return (parseInt(current.pos) < parseInt(prev.pos)) ? current : prev;
            });
          }
        }
      }

      if (item == undefined) return;

      var tempPos = section.pos;
      section.pos = item.pos;
      item.pos = tempPos;

      var self = this;
      this.$overlay.loading();
      this.$store.dispatch("files/uploadSection", section).then(function() {
        self.$store.dispatch("files/uploadSection", item).then(function() {
          self.$store.dispatch("files/loadCategories", {}).then(function() {
            self.$overlay.hide();
            section.selected = false;
          });
        });
      });
    },
    filterTable(items, search, filter) {
      var aItems = [];
      var self = this;
      items.forEach(item => {
        var bFound = false;
        var bItemAdded = false;
        
        if (
          filter(item.name.toLowerCase().trim(), search.toLowerCase().trim()) ||
          filter(item.path.toLowerCase().trim(), search.toLowerCase().trim())
        ) {
          aItems.push(item);
          bFound = true;
          bItemAdded = true;
        } else {
          Object.values(item.childs).forEach(child => {
            var bChildFound = false;
            if (
              (typeof child.name != "undefined" &&
                filter(
                  child.name.toLowerCase().trim(),
                  search.toLowerCase().trim()
                )) ||
              (typeof child.path != "undefined" &&
                filter(
                  child.path.toLowerCase().trim(),
                  search.toLowerCase().trim()
                ))
            ) {
              self.$store.commit("files/expandSection", item.id);
              if (!bItemAdded) {
                aItems.push(item);
                bItemAdded = true;
              }
              bFound = true;
            } else {
              Object.values(child.childs).forEach(child2 => {
                if (
                  (typeof child2.name != "undefined" &&
                    filter(
                      child2.name.toLowerCase().trim(),
                      search.toLowerCase().trim()
                    )) ||
                  (typeof child2.path != "undefined" &&
                    filter(
                      child2.path.toLowerCase().trim(),
                      search.toLowerCase().trim()
                    ))
                ) {
                  self.$store.commit("files/expandSection", item.id);
                  self.$store.commit("files/expandSection", child.id);
                  if (!bItemAdded) {
                    aItems.push(item);
                    bItemAdded = true;
                  }
                  bFound = true;
                  bChildFound = true;
                }
              });
            }

            if (!bChildFound) self.$store.commit("files/lessSection", child.id);
          });
        }
        if (!bFound) self.$store.commit("files/lessSection", item.id);
      });
      return aItems;
    }
  },
  watch: {
    // call again the method if the route changes
    // '$route': 'loadDataPage'
  },
  created() {
    this.$store.commit("setTitle", i18n.t('admin.views.sections.name'));
    this.$store.commit("setMenuVisible", false);

    var self = this;
    this.$store.dispatch("files/loadCategories", {}).then(function() {
      self.$store.commit("files/selectCategory", false);

      switch (self.page) {
        case "edit":
          self.$store.commit(
            "files/setCurrentSectionByID",
            self.$route.params.id
          );
          break;
        case "add":
          self.$store.commit("files/selectSection", self.empty_section);
          break;
        default:
          break;
      }
    });
  },
  beforeRouteLeave(to, from, next) {
    next();
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
button.selected {
  background-color: var(--main_color) !important;
  color: #000 !important;
}
.child {
  border-left: 5px solid var(--main_color);
  //background-color: #feffc4;
}

.child:last-child > td:last-child {
  .down {
    display: none;
  }
}

.child:first-child > td:last-child {
  .up {
    display: none;
  }
}

.child + .child2 > td:last-child {
  .up {
    display: none;
  }
}

.child2 > td:last-child {
  /*background-color: red;*/
}

.child2 {
  //border-top: 2px solid var( --secondary_color );
}
.v-icon.disabled {
  opacity: 0.2;
}
.separator {
  float: left;
  width: 30px;
  opacity: 0;
}
.sidebar-cnt {
  width: 300px;
  display: inline-block;
  float: left;
}
.content {
  width: 100%;
  display: inline-block;
  float: left;
  padding: 20px 40px 50px;
  position: relative;

  .meta {
    margin-bottom: 25px;
    overflow: hidden;

    .filter {
      float: left;
      width: 400px;
    }
    .buttons {
      float: right;
    }
  }

  .header {
    width: 100%;
    text-align: left;
    margin-bottom: 15px;
    overflow: hidden;

    .meta {
      float: left;
      width: 70%;

      .breadcrumbs {
        color: #aaa;
        display: block;
        width: 100%;

        .cat1 {
          display: inline-block;
          font-weight: bold;
          font-family: Speedee-Bold;
        }
        .cat2 {
          display: inline-block;

          &:before {
            content: "|";
            margin: 0 5px;
          }
        }
      }
      .title {
        background: var(--main_color);
        color: var(--dark_color);
        width: auto;
        display: inline-block;
        text-align: left;
        float: left;
        font-size: 25pt;
        font-family: Speedee-Bold;
        padding: 0 5px;
        margin: 0;
        margin-top: 5px;
        line-height: 25pt;
        padding-bottom: 5px;
      }
    }

    .filter {
      float: left;
      width: 30%;
      text-align: right;
      padding: 0 10px;

      .search {
        display: block;
        overflow: hidden;
        margin-top: 5px;
        -webkit-transition: all 1s;
        transition: all 1s;

        .input {
          border: none;
          border-bottom: 2px solid #ccc;
          padding: 5px;
          outline: none;
          background: url("/img/magnify.svg") no-repeat right 5px center;
          background-size: 20px;
          width: 100%;
          float: left;
        }
        .icon {
          display: none;
          cursor: pointer;
          width: 30px;
          height: 30px;
          background: url("/img/go.svg") no-repeat center var(--main_color);
          background-size: 20px;
          border-radius: 3px;
        }
        &.active {
          .input {
            width: calc(100% - 40px);
            background: transparent;
          }
          .icon {
            display: inline-block;
          }
        }
      }
    }
  }
}

tr {
  &.child {
  }
}
</style>
